import React from "react";
import ServicesHead from "./ServiceHead";
import ServicesCard from "./ServicesCard";

const ServicesMain = () => {
  return (
    <div>
      <ServicesHead />
      <ServicesCard />
    </div>
  );
};

export default ServicesMain;
